var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "8" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "4" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "PurchaseReturnInvoice" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "8" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                "item-key": "DocumentDate",
                                error: _vm.$v.form.DocumentDate,
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("NextDatePicker", {
                                attrs: {
                                  disabled: _vm.insertReadonly.DocumentDate
                                },
                                model: {
                                  value: _vm.documentDate,
                                  callback: function($$v) {
                                    _vm.documentDate = $$v
                                  },
                                  expression: "documentDate"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                "item-key": "DocumentTime",
                                error: _vm.$v.form.DocumentTime,
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("NextTimePicker", {
                                attrs: {
                                  disabled: _vm.insertReadonly.DocumentTime
                                },
                                model: {
                                  value: _vm.form.DocumentTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "DocumentTime", $$v)
                                  },
                                  expression: "form.DocumentTime"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                "item-key": "CustomerId",
                                error: _vm.$v.form.CustomerId,
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("NextDropdown", {
                                attrs: {
                                  url:
                                    "VisionNextCustomer/api/Customer/AutoCompleteSearch",
                                  searchable: true,
                                  "custom-option": true,
                                  disabled: _vm.insertReadonly.CustomerId,
                                  label: "Description1",
                                  "or-condition-fields":
                                    "Code,Description1,CommercialTitle",
                                  "dynamic-and-condition": {
                                    SalesDocumentTypeIds: [45, 46]
                                  },
                                  "is-customer": true
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.selectedSearchType(
                                      "CustomerId",
                                      $event
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.selectedCustomer,
                                  callback: function($$v) {
                                    _vm.selectedCustomer = $$v
                                  },
                                  expression: "selectedCustomer"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                "item-key": "PriceListId",
                                error: _vm.$v.form.PriceListId,
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("NextDropdown", {
                                attrs: {
                                  source: _vm.priceList,
                                  label: "Description1",
                                  disabled: _vm.insertReadonly.PriceListId
                                },
                                model: {
                                  value: _vm.selectedPrice,
                                  callback: function($$v) {
                                    _vm.selectedPrice = $$v
                                  },
                                  expression: "selectedPrice"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("b-card", { staticClass: "summary-card" }, [
                        _c("div", { staticClass: "summary-area" }, [
                          _c("span", { staticClass: "summary-title" }, [
                            _vm._v(_vm._s(_vm.$t("insert.order.netTotal")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "summary-value text-muted" },
                            [_vm._v(": " + _vm._s(_vm.form.NetTotal))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _c("hr", { staticClass: "summary-hr" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "summary-title" }, [
                            _vm._v(_vm._s(_vm.$t("insert.order.vatTotal")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "summary-value text-muted" },
                            [_vm._v(": " + _vm._s(_vm.form.TotalVat))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _c("hr", { staticClass: "summary-hr" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "summary-title" }, [
                            _vm._v(_vm._s(_vm.$t("insert.order.grossTotal")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "summary-value text-muted" },
                            [_vm._v(": " + _vm._s(_vm.form.GrossTotal))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _c("hr", { staticClass: "summary-hr" })
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.order.enterInvoice"),
                    active: ""
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "InvoiceNumber",
                            error: _vm.$v.form.InvoiceNumber,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.InvoiceNumber
                            },
                            model: {
                              value: _vm.form.InvoiceNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "InvoiceNumber", $$v)
                              },
                              expression: "form.InvoiceNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "PrintedDispatchNumber",
                            error: _vm.$v.form.PrintedDispatchNumber,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.PrintedDispatchNumber
                            },
                            model: {
                              value: _vm.form.PrintedDispatchNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "PrintedDispatchNumber", $$v)
                              },
                              expression: "form.PrintedDispatchNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "InvoiceKindId",
                            error: _vm.$v.form.InvoiceKindId,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              label: "Description1",
                              disabled: _vm.insertReadonly.InvoiceKindId,
                              url: "VisionNextInvoice/api/InvoiceKind/Search"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "InvoiceKindId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedInvoiceKind,
                              callback: function($$v) {
                                _vm.selectedInvoiceKind = $$v
                              },
                              expression: "selectedInvoiceKind"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DocumentNumber",
                            error: _vm.$v.form.DocumentNumber,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.DocumentNumber
                            },
                            model: {
                              value: _vm.form.DocumentNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "DocumentNumber", $$v)
                              },
                              expression: "form.DocumentNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Description1",
                            error: _vm.$v.form.Description1,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.Description1
                            },
                            model: {
                              value: _vm.form.Description1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Description1", $$v)
                              },
                              expression: "form.Description1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CurrencyId",
                            error: _vm.$v.form.CurrencyId,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.CurrencyId,
                              source: _vm.currencies
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "CurrencyId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedCurrency,
                              callback: function($$v) {
                                _vm.selectedCurrency = $$v
                              },
                              expression: "selectedCurrency"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "WarehouseId",
                            error: _vm.$v.form.WarehouseId,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              label: "Description1",
                              url:
                                "VisionNextWarehouse/api/Warehouse/AutoCompleteSearch",
                              disabled: _vm.insertReadonly.WarehouseId,
                              searchable: ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "WarehouseId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedWarehouse,
                              callback: function($$v) {
                                _vm.selectedWarehouse = $$v
                              },
                              expression: "selectedWarehouse"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DocumentReference",
                            error: _vm.$v.form.DocumentReference,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled:
                                _vm.insertReadonly.DocumentReference ||
                                (_vm.EDocumentStatus.Code != "SendToEfuError" &&
                                  _vm.EDocumentStatus.Code !=
                                    "ReadyForSendToEFU")
                            },
                            model: {
                              value: _vm.form.DocumentReference,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "DocumentReference", $$v)
                              },
                              expression: "form.DocumentReference"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DocumentReferenceDate",
                            error: _vm.$v.form.DocumentReferenceDate,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: {
                              disabled:
                                _vm.insertReadonly.DocumentReferenceDate ||
                                (_vm.EDocumentStatus.Code != "SendToEfuError" &&
                                  _vm.EDocumentStatus.Code !=
                                    "ReadyForSendToEFU")
                            },
                            model: {
                              value: _vm.documentReferenceDate,
                              callback: function($$v) {
                                _vm.documentReferenceDate = $$v
                              },
                              expression: "documentReferenceDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("insert.order.enterProducts") } },
                [
                  _c(
                    "b-row",
                    [
                      _c("NextExportDetail", {
                        attrs: {
                          url:
                            "VisionNextInvoice/api/PurchaseReturnInvoice/ExcelExportItems",
                          "record-id": _vm.form.RecordId,
                          "record-key": "invoiceId",
                          "file-name": _vm.$t("insert.order.enterProducts")
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-table-simple",
                        { attrs: { bordered: "", small: "" } },
                        [
                          _c(
                            "b-thead",
                            [
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("insert.order.product")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("insert.order.productCode"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("insert.order.quantity"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("insert.order.price")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("insert.order.vatRate")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("insert.order.netTotal"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("insert.order.vatTotal"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("insert.order.grossTotal"))
                                  )
                                ])
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tbody",
                            _vm._l(
                              _vm.form.InvoiceLines
                                ? _vm.form.InvoiceLines.filter(function(x) {
                                    return x.RecordState != 4
                                  })
                                : [],
                              function(o, i) {
                                return _c(
                                  "b-tr",
                                  { key: i },
                                  [
                                    _c("b-td", [_vm._v(_vm._s(o.Item.Label))]),
                                    _vm._v(" "),
                                    _c("b-td", [_vm._v(_vm._s(o.Item.Code))]),
                                    _vm._v(" "),
                                    _c("b-td", [_vm._v(_vm._s(o.Quantity))]),
                                    _vm._v(" "),
                                    _c("b-td", [_vm._v(_vm._s(o.Price))]),
                                    _vm._v(" "),
                                    _c("b-td", [_vm._v(_vm._s(o.VatRate))]),
                                    _vm._v(" "),
                                    _c("b-td", [_vm._v(_vm._s(o.NetTotal))]),
                                    _vm._v(" "),
                                    _c("b-td", [_vm._v(_vm._s(o.TotalVat))]),
                                    _vm._v(" "),
                                    _c("b-td", [_vm._v(_vm._s(o.GrossTotal))])
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("insert.referenceDocuments") } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            md: "3",
                            lg: "3",
                            title: _vm.$t("insert.referenceInvoiceNumber")
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              maxLength: 16,
                              disabled: _vm.insertReadonly.DocumentReference
                            },
                            on: { input: _vm.onRefNumberInput },
                            nativeOn: {
                              keydown: function($event) {
                                return _vm.onRefNumberKeydown($event)
                              }
                            },
                            model: {
                              value: _vm.newReference.number,
                              callback: function($$v) {
                                _vm.$set(_vm.newReference, "number", $$v)
                              },
                              expression: "newReference.number"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            md: "3",
                            lg: "3",
                            title: _vm.$t("insert.referenceDocumentDate")
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: {
                              disabled: _vm.insertReadonly.DocumentReferenceDate
                            },
                            model: {
                              value: _vm.newReference.date,
                              callback: function($$v) {
                                _vm.$set(_vm.newReference, "date", $$v)
                              },
                              expression: "newReference.date"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "text-right",
                          attrs: { cols: "12", md: "2", lg: "2" }
                        },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("AddDetailButton", {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.addReferenceDocument($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-table-simple",
                        { attrs: { bordered: "", small: "" } },
                        [
                          _c(
                            "b-thead",
                            [
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("insert.referenceInvoiceNumber")
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("insert.referenceDocumentDate")
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("list.operations")))
                                ])
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tbody",
                            _vm._l(_vm.referenceDocuments, function(r, i) {
                              return _c(
                                "b-tr",
                                { key: i },
                                [
                                  _c("b-td", [_vm._v(_vm._s(r.number))]),
                                  _vm._v(" "),
                                  _c("b-td", [
                                    _vm._v(_vm._s(_vm.formatDateOnly(r.date)))
                                  ]),
                                  _vm._v(" "),
                                  _c("b-td", { staticClass: "text-center" }, [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-edit text-warning mr-2",
                                      on: {
                                        click: function($event) {
                                          return _vm.editReferenceDocument(i)
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "far fa-trash-alt text-danger",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeReferenceDocument(i)
                                        }
                                      }
                                    })
                                  ])
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13a80a80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13a80a80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PurchaseReturnInvoice/update.vue
// module id = null
// module chunks = 